import { Component, Input, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { UserInfo } from '../../../views/authentification/models/user.model';
import { AuthService } from '../../../views/authentification/services/auth.service';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  saxArrowLeft2Outline,
  saxProfileTickOutline,
} from '@ng-icons/iconsax/outline';

@Component({
  selector: 'app-navigation-bar-back',
  standalone: true,
  imports: [NgIf, NgIcon],
  providers: [
    provideIcons({
      saxArrowLeft2Outline,
      saxProfileTickOutline,
    }),
  ],
  templateUrl: './navigation-bar-back.component.html',
  styleUrl: './navigation-bar-back.component.scss',
})
export class NavigationBarBackComponent implements OnInit {
  @Input() previousPageUrl?: string;

  user?: UserInfo;

  constructor(
    private _authService: AuthService,
    private _router: Router
  ) {}

  ngOnInit(): void {
    this._authService.getUserInfo().subscribe((userInfo: UserInfo) => {
      if (userInfo) {
        this.user = userInfo;
      }
    });
  }

  returnToPreviousPage() {
    this._router.navigateByUrl(this.previousPageUrl ?? '/dashboard');
  }
}
